// ═════════════════════════════════════════════════════════════════════════
// LES QUATRE DESTINATIONS D'UN RÉSULTAT VALIDÉ, EN UN SEUL ENDROIT.
//
// ⚠ SECOND AXE, PAS REMPLACEMENT. `professional_decision`
// (accepted / corrected) répond à « la machine a-t-elle bien recopié ».
// La destination répond à « à quoi ça sert ». Une valeur peut être
// parfaitement transcrite ET relever du médecin : confondre les deux axes
// obligerait à refuser une donnée juste pour l'écarter du programme, et on
// perdrait la trace de sa lecture.
//
// ⚠ `a_verifier` EST LE DÉFAUT, et il l'est partout : dans la RPC, dans le
// client, dans l'écran. Le silence ne vaut jamais « bon pour le programme ».
//
// ⚠ AUCUNE RÈGLE CLINIQUE ICI. Ce module ne connaît aucun marqueur et ne
// déduit aucune destination d'un nom ou d'une valeur. Anissa tranche, seule ;
// voir la doctrine d'autorité clinique du projet.
//
// Ce fichier ne contient QUE des chaînes et n'importe RIEN — c'est ce qui lui
// permet d'être lu côté serveur comme côté navigateur.
// ═════════════════════════════════════════════════════════════════════════

export const ROUTE_PROGRAMME = 'programme';
export const ROUTE_CONTEXTE = 'contexte';
export const ROUTE_A_VERIFIER = 'a_verifier';
export const ROUTE_AVIS_MEDICAL = 'avis_medical';

/** ⚠ L'ordre est celui de la contrainte SQL ; le test de migration l'exige. */
export const MGD_CLINICAL_ROUTES = Object.freeze([
  ROUTE_PROGRAMME, ROUTE_CONTEXTE, ROUTE_A_VERIFIER, ROUTE_AVIS_MEDICAL,
]);

/** La destination par défaut, la seule qui n'engage rien. */
export const MGD_CLINICAL_ROUTE_DEFAUT = ROUTE_A_VERIFIER;

export const estRouteCliniqueConnue = (valeur) => MGD_CLINICAL_ROUTES.includes(valeur);

/** Libellés d'interface. Aucun n'affirme quoi que ce soit de clinique. */
export const MGD_CLINICAL_ROUTE_LABELS = Object.freeze({
  [ROUTE_PROGRAMME]: 'Programme',
  [ROUTE_CONTEXTE]: 'Contexte',
  [ROUTE_A_VERIFIER]: 'À vérifier',
  [ROUTE_AVIS_MEDICAL]: 'Avis médical',
});
